/**
 * VOCI DEL CORE SPEGNIBILI (FILO-53) — le voci che la pagina «Voci del CRM» di Liferay spegne per
 * company. Il server le consegna in `user.disabledCoreItems`; qui c'è cosa ciascuna si porta via.
 *
 * Le chiavi sono un contratto con il backend: coincidono con `CoreItemKeys.SWITCHABLE` in crm-util
 * e con le `key` delle voci del menu (`Sidebar`). Cambiando una delle tre liste, cambiare le altre
 * nello stesso commit. Contatti, Aziende e Impostazioni non ci sono: restano sempre accesi.
 *
 * Puro, senza React: lo usa anche un file `.check.ts` che gira in node.
 */

export interface CoreItem {
  key: string;
  /**
   * Le rotte della voce: loro e le loro sottopagine si chiudono quando la voce è spenta. Più d'una
   * quando la voce ha pagine fuori dal suo prefisso (Contatti rapidi).
   */
  paths: readonly string[];
  /** Il tipo di record della voce: spenta, il tipo sparisce da tutta l'interfaccia. */
  entityType?: string;
}

export const CORE_ITEMS: readonly CoreItem[] = [
  { key: 'dashboard', paths: ['/dashboard'] },
  { key: 'map', paths: ['/map'] },
  { key: 'quotations', paths: ['/quotations'], entityType: 'Quotation' },
  { key: 'kanban', paths: ['/kanban'] },
  { key: 'inbox', paths: ['/inbox'] },
  { key: 'surveillance', paths: ['/surveillance'] },
  { key: 'automations', paths: ['/automations'] },
  { key: 'whatsapp', paths: ['/whatsapp'] },
  { key: 'rapid-contacts', paths: ['/rapid-contacts', '/add-rapid-contact', '/rapid-contact'] },
];

/**
 * Vero se `path` è la rotta di una voce spenta o una sua sottopagina. La query non conta: vale
 * anche per un link come `/inbox?messageId=5`, oltre che per i pattern delle rotte.
 */
export function isPathDisabled(path: string, disabled: ReadonlySet<string>): boolean {
  const pathname = path.split('?')[0];
  return CORE_ITEMS.some(
    (item) =>
      disabled.has(item.key) &&
      item.paths.some((p) => pathname === p || pathname.startsWith(`${p}/`)),
  );
}

/** I tipi di record delle voci spente. */
export function disabledEntityTypesOf(disabled: ReadonlySet<string>): ReadonlySet<string> {
  return new Set(
    CORE_ITEMS.filter((item) => item.entityType && disabled.has(item.key)).map((item) => item.entityType as string),
  );
}
